const img = require('./arrow_backward_m_action-2.png'); export default img;